<template>
  <main role="main">
    <b-container class="py-4">
      <div v-if="isLoading" class="py-5 text-center text-secondary">{{ $t("loadingData") }}</div>

      <template v-else>
        <section>
        <!--Thông tin tài khoản-->
          <h4>{{ $t("accountInfo") }} </h4>
          <b-row>
            <b-col lg="6" class="mb-3 mb-lg-0">
              <b-row v-if="saleAreaInfo">
                <b-col cols="4"><span class="text-secondary">{{ $t("saleArea2") }}</span></b-col>
                <b-col cols="8">{{ saleAreaInfo.name }}</b-col>
              </b-row>
              <b-row>
                <b-col cols="4"><span class="text-secondary">{{ $t("accountId") }}:</span></b-col>
                <b-col cols="8">{{ user.id }}</b-col>
              </b-row>
              <b-row>
                <b-col cols="4"><span class="text-secondary">{{ $t("username") }}:</span></b-col>
                <b-col cols="8">{{ user.username }}</b-col>
              </b-row>
              <b-row>
                <b-col cols="4"><span class="text-secondary">{{ $t("fullName") }}:</span></b-col>
                <b-col cols="8" class="text-break">{{ user.name }}</b-col>
              </b-row>
              <b-row>
                <b-col cols="4"><span class="text-secondary">Email:</span></b-col>
                <b-col cols="8" class="text-break">{{ user.email }}</b-col>
              </b-row>
              <b-row>
                <b-col cols="4"><span class="text-secondary">{{ $t("phoneNumber") }}:</span></b-col>
                <b-col cols="8">{{ user.phone }}</b-col>
              </b-row>
              <b-row v-if="user.address">
                <b-col cols="4"><span class="text-secondary">{{ $t("address") }}:</span></b-col>
                <b-col cols="8" class="text-break">{{ user.address }}</b-col>
              </b-row>
            </b-col>
            <b-col lg="6" class="mb-3 mb-lg-0" v-if="appInfo">
              <b-row>
                <b-col cols="4"><span class="text-secondary">{{ $t("appName") }}</span></b-col>
                <b-col cols="8">{{ appInfo.name }}</b-col>
              </b-row>
              <b-row>
                <b-col cols="4"><span class="text-secondary">{{ $t("domain") }}</span></b-col>
                <b-col cols="8">{{ appInfo.domainName }}</b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col cols="4"><span class="text-secondary">Logo</span></b-col>
                <b-col cols="8">
                  <div v-if="appInfo.logo" class="logo-container bg-primary mb-2">
                    <img :src="appInfo.logo" alt="logo">
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <div class="mt-3">
            <b-button variant="outline-primary" class="mr-3" v-b-modal:edit-personal-info>
              {{ $t("updateInfo") }}
            </b-button>
            <b-button variant="outline-danger" class="mr-3" to="/change-password">
              {{ $t("changePassword") }}
            </b-button>
            <!-- <b-button  v-if="!isUserAdmin() && !isManager()" variant="outline-danger" class="mr-3" @click="deleteAccount">
              {{ $t("deleteAccount") }}
            </b-button> -->
            <b-button v-if="appInfo" variant="outline-secondary" class="mr-3" v-b-modal:update-customer-app-modal>
              {{ $t("updateApp") }}
            </b-button>
          </div>
        </section>

        <!--Thông tin Khách hàng-->
        <section class="pt-4 mt-4 border-top" v-if="customerInfo">
          <h4 class="mb-4">{{ $t("customerInfo") }}</h4>
          <b-row>
            <b-col lg="6">
              <b-row>
                <b-col cols="4"><span class="text-secondary">{{ $t("customerId") }}:</span></b-col>
                <b-col cols="8">{{ customerInfo.customerCode }}</b-col>
              </b-row>
              <b-row>
                <b-col cols="4"><span class="text-secondary">{{ $t("customerName") }}:</span></b-col>
                <b-col cols="8">{{ customerInfo.name }}</b-col>
              </b-row>
              <b-row>
                <b-col cols="4"><span class="text-secondary">{{ $t("customerType") }}:</span></b-col>
                <b-col cols="8">{{ customerType }}</b-col>
              </b-row>
              <!-- <b-row v-if="customerInfo.corporations">
                <b-col cols="4"><span class="text-secondary">{{ $t("underTheUnit") }}:</span></b-col>
                <b-col cols="8">{{ corporationsText }}</b-col>
              </b-row>
              <b-row v-else>
                <b-col cols="4"><span class="text-secondary">{{ $t("ownedBy") }}:</span></b-col>
                <b-col cols="8">{{ idTypeText }}</b-col>
              </b-row> -->
              <b-row>
                <b-col cols="4"><span class="text-secondary">Email:</span></b-col>
                <b-col cols="8">{{ customerInfo.email }}</b-col>
              </b-row>
              <b-row>
                <b-col cols="4"><span class="text-secondary">{{ $t("phoneNumber") }}:</span></b-col>
                <b-col cols="8">{{ customerInfo.phoneNumber }}</b-col>
              </b-row>
              <b-row>
                <b-col cols="4"><span class="text-secondary">{{ $t("province") }}:</span></b-col>
                <b-col cols="8">{{ customerInfo.province }}</b-col>
              </b-row>
              <b-row>
                <b-col cols="4"><span class="text-secondary">{{ $t("address") }}:</span></b-col>
                <b-col cols="8">{{ customerInfo.address }}</b-col>
              </b-row>
            </b-col>
            <!-- <b-col lg="6">
              <b-row v-if="customerInfo.taxCode">
                <b-col cols="4"><span class="text-secondary">{{ $t("taxCode") }}:</span></b-col>
                <b-col cols="8">{{ customerInfo.taxCode }}</b-col>
              </b-row>
              <b-row>
                <b-col cols="4"><span class="text-secondary">{{ $t("documentType") }}:</span></b-col>
                <b-col cols="8">{{ customerInfo.documentTypeName }}</b-col>
              </b-row>
              <b-row>
                <b-col cols="4"><span class="text-secondary">{{ $t("documentNumber") }}:</span></b-col>
                <b-col cols="8">{{ customerInfo.taxCode }}</b-col>
              </b-row>
              <b-row>
                <b-col cols="4"><span class="text-secondary">{{ $t("issueDate") }}:</span></b-col>
                <b-col cols="8">{{ localDateFormat(customerInfo.licenseDate) }}</b-col>
              </b-row>
              <b-row>
                <b-col cols="4"><span class="text-secondary">{{ $t("expDate") }}:</span></b-col>
                <b-col cols="8">{{ localDateFormat(customerInfo.licenseExpirationDate) }}</b-col>
              </b-row>
              <b-row>
                <b-col cols="4"><span class="text-secondary">{{ $t("issuePlace") }}:</span></b-col>
                <b-col cols="8">{{ customerInfo.licensePlace }}</b-col>
              </b-row>
            </b-col> -->
          </b-row>
          <!-- <div class="mt-3">
            <b-button variant="outline-primary" class="mr-3" v-b-modal:edit-customer-info>
              {{ $t("updateCustomerInfo") }}
            </b-button>
          </div> -->
        </section>
        <!-- Thông tin gói cước -->
       <section class="pt-4 mt-4 border-top" v-if="customerPackageInfo">
          <h4>{{ $t("subscriptionInfo") }}</h4>
          <div class="flex justify-end -mt-3">
            <span v-if="!customerPackageIsExpired">
              <span class="px-2 py-0.5 badge-status unexpired">{{$t('unexpired')}}</span>
            </span>
            <span v-if="customerPackageIsExpired">
              <span class="px-2 py-0.5 badge-status expired">{{$t('expired')}}</span> 
            </span>
          </div>
          <div class="px-4 py-3 my-4 border rounded" v-if="customerPackageInfo">
            <div class="align-items-center mb-3">
              
              <b-col md="6" class="pl-0">
                <h6>
                  <b>{{ customerPackageInfo.subscriptionPlanName }} </b>
                  <span>| {{ customerPackagePrice }} </span>  
                  <span>| {{ $t("storage") }} {{ customerPackageRetention }}</span>           
                </h6>
              </b-col>
                <b-row>
                  <b-col md="6">
                    <div class="ml-4">
                    <li v-for="(item, index) in customerPackageItems" :key="index" class="mb-2">
                      {{ $t(item.key, { count: item.value }) }}
                    </li>
                  </div>
                  </b-col>
                  <b-col v-if="customerFeatures" md="4">
                    <div v-for="feature in customerFeatures.slice(0, 5)" :key="feature.featureId" class="d-flex align-items-center mb-2">
                      <b-icon icon="check2" class="mr-2 primary-color"/>
                      <span>{{ feature.featureName }}</span>
                    </div>

                    <div v-if="customerFeatures.length > 5" class="d-flex pl-4 primary-color">
                      <a class="primary-color" style="cursor: pointer;font-size: 15px;margin-left: 5px;" 
                        v-b-tooltip.bottom.hover.html="{ title: customerFeatureTooltip, customClass: 'tooltip-class' }">
                          {{$t("viewmore")}} 
                        <i class="fa fa-angle-right" style="font-size: 14px" aria-hidden="true"></i>
                      </a>
                    </div>
                  </b-col>
                </b-row>
            </div>
            <b-row class="border-top mt-2">
              <b-col md="4" class="mt-2">
                <span class="text-secondary">{{ $t("subCreatedDate") }}:</span> {{ localDateFormat(customerPackageInfo.createdTime) }}
              </b-col>
              <b-col md="4" class="mt-2">
                <span class="text-secondary">{{ $t("startDate") }}:</span> {{ localDateFormat(customerPackageInfo.startTime) }}
              </b-col>
              <b-col md="4" class="mt-2">
                <span class="text-secondary">{{ $t("expDate") }}:</span> {{ localDateFormat(customerPackageInfo.endTime) }}
              </b-col>
            </b-row>
          </div>
          
          <div v-else class="text-secondary">{{ $t("noActiveSub") }}
          </div>
        </section>
        <!-- Giao diện token -->
        <section class="pt-4 mt-4 border-top" v-if="gmTokenInfo">
          <b-row class="mr-0 ml-0 d-flex justify-content-between align-items-center">
            <h4>{{ $t("tokenInfo") }}</h4>
            <div>
              <b-button variant="outline-primary" class="detail-btn mr-2" @click="onOpenGuideGMToken()">
                {{ $t("viewTemplateAPIImportContact") }}
              </b-button>
              <b-button variant="outline-primary"  class="detail-btn" @click="onCopyGMToken()">
                {{ $t("copy") }}
              </b-button>
            </div>
          </b-row>
          <div class="px-4 py-3 my-4 border rounded">
            <b-row class="align-items-center">
              <b-col md="12">
                <h5  class="token">{{gmTokenInfo.token}}</h5>
                <h5  class="token-expire mt-1">Hết hạn: {{gmTokenInfo.expired}}</h5>
              </b-col>
            </b-row>
          </div>
        </section>
        
        <!-- Giao diện dung lượng lưu trữ -->
        <section class="pt-4 mt-4 border-top" v-if="isCustomer() && customerPackageInfo">
          <b-row class="mr-0 ml-0 d-flex justify-content-between align-items-center">
            <h4>{{ $t("totalRecordingSize") }}</h4>
            <b-button variant="outline-primary" class="detail-btn" @click="onOpenManageStorage">{{ $t("details") }}</b-button>
          </b-row>

          <b-row>
            <b-col :md="showAiQuota ? 6 : 12">
              <div class="px-4 py-3 my-4 border rounded">
                <h5 class="mb-3">{{ $t("storageCapacity") }}</h5>
                <b-progress class="mb-2" :max="storageMaxValue" >
                  <b-progress-bar
                    :value="storageUsedValue"
                    :style="{ backgroundColor: storageStatusColor }"
                    :label="`${Math.round((storageUsedValue / storageMaxValue) * 100)}%`"/>
                </b-progress>
                <div class="text-small">
                  {{ $t("displayStorageUsed", { used: storageUsedValue, total: storageMaxValue}) }} ({{ $t("freeStorage", { storage: Math.max(0, storageMaxValue - storageUsedValue).toFixed(2) }) }})
                </div>
                <div class="text-small">
                  {{ $t("attention") }}: {{ $t("storageExpiredDay", {day: storageRetentionValue}) }}
                </div>
              </div>
            </b-col>
            <b-col md="6" v-if="showAiQuota">
              <div class="px-4 py-3 my-4 border rounded">
                <h5 class="mb-3">{{ $t("quotaTotal") }}</h5>
                <b-progress class="mb-2" :max="aiQuotaProgressMax" >
                  <b-progress-bar
                    :value="aiQuotaProgressValue"
                    :style="{ backgroundColor: aiQuotaStatusColor }"
                    :label="aiQuotaProgressLabel"/>
                </b-progress>
                <div class="text-small">
                  <template v-if="isAiUnlimited">
                    <div>
                      {{ $t("displayQuotaUsed", { used: aiQuotaUsedMinutes }) }}
                    </div>
                    {{ $t("aiQuotaUnlimited") }}
                  </template>
                  <template v-else>{{ $t("displayQuotaUsedAndTotal", { used: aiQuotaUsedMinutes, total: aiQuotaTotalMinutes }) }} ({{ $t("freeQuota", { remaining: aiQuotaRemainingMinutes }) }})</template>
                </div>
                <div v-if="!isAiUnlimited" class="text-small">
                  {{ $t("storageQuotaReset", { date: aiQuotaCycleStartFormatted }) }}
                </div>
              </div>
            </b-col>
          </b-row>
        </section>
      </template>

    </b-container>

    <b-modal id="edit-personal-info" :title="$t('updateAccountInfo')" hide-footer no-close-on-backdrop>
      <EditPersonalInfoModal modal-id="edit-personal-info" @submitted="onReloadPage" />
    </b-modal>

    <!-- <b-modal id="edit-customer-info" :title="$t('updateCustomerInfo')" hide-footer no-close-on-backdrop>
      <EditCustomerInfoModal modal-id="edit-customer-info" />
    </b-modal> -->

    <b-modal id="change-password-modal" :title="$t('changePassword')" hide-footer no-close-on-backdrop>
      <ChangePasswordModal modal-id="change-password-modal" />
    </b-modal>

    <b-modal id="update-customer-app-modal" :title="$t('updateApp')" hide-footer no-close-on-backdrop>
      <UpdateCustomerAppModal modal-id="update-customer-app-modal" :item="appInfo" @submitted="onReloadPage" />
    </b-modal>
  </main>
</template>

<style lang="scss">
  .logo-container {
    flex-shrink: 0;
    width: 50px; height: 50px;
    display: grid; place-items: center;

    > img {
      width: 28px;
    }
  }

  .token {
    overflow-wrap: break-word;
    font-size: 16px;
    color: #004f9e;
  }

  .token-expire {
    overflow-wrap: break-word;
    font-size: 14px;
  }

  .badge-status {
  float: right;
  color: white;
  padding: 0px 4px;
  margin: 0.25rem 0.5rem !important;
  border-radius: 5px;
  font-size: 10pt !important;
}

.badge-status.unexpired {
  border: 1px solid green;
  background-color: green;
}

.badge-status.expired {
  border: 1px solid red;
  background-color: red;
}
.detail-btn{
  font-size: 14px !important;
  padding: 4px 8px !important;
}
.text-small{
  font-size: 14px !important;
}
.tooltip-class .tooltip-inner .tooltip-feature {
  margin-bottom: 8px;
}
</style>

<script lang="ts">
  import { Component, Vue } from 'vue-property-decorator';
  import _ from 'lodash';
  import moment from 'moment';

  /// Base & Enums
  import BaseComponent from '@/components/BaseComponent';
  import { Status } from '@/views/enums/EnableStatus';
  import { StorageType } from '@/views/enums/storageType';
  import { featureCode } from '@/views/enums/featureCode';

  /// Services & Util
  import * as userService from '@/service/userService';
  import * as customerService from '@/service/customerService';
  import * as areaService from '@/service/areaService';
  import * as subscriptionPlanService from '@/service/subscriptionPlanService';
  import * as util from "@/service/util";
  import * as subscriptionUtil from "@/service/subscriptionUtil";
  import * as aiQuotaUtils from '@/service/aiQuotaUtils';

  /// Components (Modals)
  import ChangePasswordModal from '@/components/account/ChangePasswordModal.vue';
  import EditPersonalInfoModal from '@/components/account/EditPersonalInfoModal.vue';
  import UpdateCustomerAppModal from '@/components/app-names/UpdateCustomerAppModal.vue';
  import ManageStorageModal from '@/components/storage/ManageStorageModal.vue';
  import { CustomerFeature } from "@/model/CustomerFeatureInfo";

  @Component({
    components: { ChangePasswordModal, EditPersonalInfoModal, UpdateCustomerAppModal, ManageStorageModal }
  })
  export default class ManageAccount extends BaseComponent {
    id: number = null;
   
    ///
    appInfo = null;

    ///
    isLoading = true;

    /// Khu vực kinh doanh
    saleAreaInfo = null;

    /// Thông tin khách hàng
    customerInfo = null;

    /// Thông tin gói cước của Khách hàng
    customerPackageInfo = null;

    /// Thông tin cấu hình chức năng của Khách hàng
    customerFeatures: CustomerFeature[] = [];

    /// Thông tin gói cước của hệ thống
    systemPackageInfo = null;

    /// Thông tin token tích hợp
    gmTokenInfo = null;

    /// Props
    /// Loại Khách hàng
    customerType: string = '';

    /// Kiểm tra gói cước của Khách hàng đã hết hạn hay chưa
    customerPackageIsExpired: boolean = false;

    /// Chi tiết các mục thông số trong gói cước
    customerPackageItems = [];

    /// Thông tin các chức năng ở tooltip
    customerFeatureTooltip = '';

    /// Giá gói cước
    customerPackagePrice = '';

    /// Thời gian lưu trữ của gói cước (hiển thị text)
    customerPackageRetention = '';

    /// Mã màu cho trạng thái dung lượng của gói cước
    storageStatusColor = '#dc3545';

    /// Giá trị dung lượng đã sử dụng
    storageUsedValue: number = 0;

    /// Giá trị dung lượng tối đa + dung lượng đã mua thêm
    storageMaxValue: number = 0;

    /// Giá trị thời gian lưu trữ của dung lượng, mặc định: `util.getDefaultStorageRetention()`
    storageRetentionValue: number = 0;

    mounted() {
      this.fetchData();
    }

    ///
    async fetchData() {
      try {
        ///
        this.isLoading = true;

        ///
        await this.getUserInfo();

        /// MANAGER
        if (this.isManager()) {
          await this.getSaleAreaInfo();
          return;
        }

        /// CUSTOMER
        if (this.isCustomer()) {
          try { await this.getCustomerInfo(); }
          catch (e) { console.warn('❌ getCustomerInfo failed:', e); }

          try { await this.getCustomerPackageInfo(); }
          catch (e) { console.warn('❌ getCustomerPackageInfo failed:', e); }

          try { await this.getCustomerFeatures(); }
          catch (e) { console.warn('❌ getCustomerFeatures failed:', e); }

          try { await this.getSystemPackageInfo(); }
          catch (e) { console.warn('❌ getSystemPackageInfo failed:', e); }

          try { await this.getGMTokenInfo(); }
          catch (e) { console.warn('❌ getGMTokenInfo failed:', e); }

          ///
          this.updateProps();
          
          ///
          return;
        }
      } catch (e) {
        this.toastError(e);
      } finally {
        this.isLoading = false;
      }
    }

    /// Thông tin khu vực kinh doanh
    async getSaleAreaInfo() {
      const saleAreas = await areaService.getAll();
      this.saleAreaInfo = saleAreas.find(it => it.id === this.user.saleAreaId);
      util.printLog('getSaleAreaInfo', this.saleAreaInfo);
      return this.saleAreaInfo;
    }

    /// Thông tin tài khoản
    async getUserInfo() {
      this.user = await userService.getUserDetail();
      util.printLog('getUserInfo', this.user);
      return this.user;    
    }

    /// Thông tin Khách hàng
    async getCustomerInfo() {
      this.customerInfo = await customerService.getDetails(this.user.customerId);
      util.printLog('getCustomerInfo', this.customerInfo);
      return this.customerInfo;
    }

    /// Thông tin gói cước của Khách hàng
    async getCustomerPackageInfo() {

      ///
      if (!this.customerInfo) {
        return null;
      }

      ///
      const customerSubPlan = await subscriptionPlanService.getCustomerSubscription(this.customerInfo.id);
      this.customerPackageInfo = customerSubPlan.find(it => it.isActive);
      util.printLog('getCustomerPackageInfo', this.customerPackageInfo);
      return this.customerPackageInfo;  
    }

    /// Thông tin các chức năng của Khách hàng
    async getCustomerFeatures() {

      ///
      if (!this.customerInfo) {
        return null;
      }

      /**
       * sử dụng sortedFeatures để sắp xếp mảng theo featureId tăng dần
       */
      const customerFeature = await customerService.getCustomerFeature(this.customerInfo.id);
      this.customerFeatures = this.sortedFeatures(customerFeature.features.filter(feature => feature.isActive ===  Status.ENABLE));
      util.printLog('getCustomerFeatures', this.customerFeatures);
      return this.customerFeatures;
    }

    /// Thông tin gói cước của hệ thống
    async getSystemPackageInfo() {

      ///
      if (!this.customerPackageInfo) {
        return null;
      }

      ///
      this.systemPackageInfo = await subscriptionPlanService.getPackageDetail(this.customerPackageInfo.subscriptionPlanId);
      util.printLog('getSystemPackageInfo', this.systemPackageInfo);
      return this.systemPackageInfo;
    }

    /// Thông tin token tích hợp (GMToken)
    async getGMTokenInfo(){

      ///
      if (!this.customerInfo) {
        return null;
      }

      ///
      const isActiveGMToken = this.customerInfo.activeGMToken === Status.ENABLE;
      if (isActiveGMToken) {
        try {
          this.gmTokenInfo = await customerService.getGMTokenByUser(this.userId);
          util.printLog('getGMTokenInfo', this.gmTokenInfo);
          return this.gmTokenInfo;
        } catch (error) {
          return null;
        }
      }
    }

    /// Cập nhật các props của page
    updateProps() {
      ///-----------------------------------------

      ///Check KH có dùng gói cước hay không
      if (!this.customerPackageInfo) {
        return;
      }

      /// Customer Type
      const cusType = this.customerInfo?.customerType?.toLowerCase();
      this.customerType = this.$t(cusType).toString();

      ///-----------------------------------------
      /// Check Customer Package Expired
      let isExpiredPackage = false;
      if (this.customerPackageInfo.endTime) {
        try {
          isExpiredPackage = !util.isCustomerPackageValid(this.customerPackageInfo.endTime);
        } catch (error) {
          isExpiredPackage = true;
          console.error('=== getRemainingDaysOfPackage_err', error);
        }
      }
      
      ///
      this.customerPackageIsExpired = isExpiredPackage;

      ///-----------------------------------------
      this.customerPackageItems = subscriptionUtil.buildCustomerPackageItems(this.customerPackageInfo, this.systemPackageInfo);

      ///-----------------------------------------
      const checkIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="white" style="margin-right: 5px;" viewBox="0 0 16 16">
        <path d="M13.854 3.646a.5.5 0 0 1 0 .708L6.707 11.5 2.146 6.854a.5.5 0 1 1 .708-.708L6.707 10.293l6.439-6.439a.5.5 0 0 1 .708 0z"/>
      </svg>`;
      this.customerFeatureTooltip = this.customerFeatures
        .map(f => `<div class="tooltip-feature">${checkIcon}${f.featureName}</div>`)
        .join('');

      ///-----------------------------------------
      if (this.systemPackageInfo) {
        const { price, numberOfDaysUsage, unitTimeVN } = this.systemPackageInfo;
        const strPrice = this.formatCurrencyAmount(price) + ' VND';
        this.customerPackagePrice = `${strPrice}/${numberOfDaysUsage} ${unitTimeVN }`;
      }

      ///-----------------------------------------
      if (this.customerPackageInfo) {
        const { storage } = this.customerPackageInfo;
        const retention = storage.retention ?? util.getDefaultStorageRetention();
        const strType = (storage.type ?? StorageType.Fixed) == StorageType.ConcurrentMeeting ? `/1CH` : '';
        const strDay = "ngày";
        const unitStorage = 'GB';
        const size = util.bytesToGB(storage.maxSize);
        this.customerPackageRetention = `${size}${unitStorage}${strType}/${retention} ${strDay}`;
      }
        ///-----------------------------------------
      //dung lượng đã dùng
      this.storageUsedValue = util.bytesToGB(this.customerInfo?.usedStorageSize ?? 0, true, 2);
      //dung lượng tối đa (gói cước + mua thêm)
      this.storageMaxValue = util.bytesToGB(util.getMaxStorage(this.customerInfo?.maxStorageSize ?? 0, this.customerInfo?.purchasedStorageSize ?? 0));
      //ngày lưu trữ
      this.storageRetentionValue = this.customerPackageInfo?.retention ?? util.getDefaultStorageRetention();
      //màu trạng thái dung lượng
      this.storageStatusColor = util.getStorageStatusColor(this.storageUsedValue, this.storageMaxValue);
    }

    /// AI Quota object từ customerInfo
    get aiQuota() {
      return this.customerInfo?.aiQuota ?? null;
    }

    get hasAIFeature(): boolean {
      return aiQuotaUtils.hasAIFeature(this.customerFeatures);
    }

    get showAiQuota(): boolean {
      return aiQuotaUtils.showAiQuota(this.hasAIFeature, this.aiQuota);
    }

    /// Kiểm tra AI không giới hạn (aiQuotaType === 3)
    get isAiUnlimited(): boolean {
      return aiQuotaUtils.isAiUnlimited(this.aiQuota);
    }

    /// Số phút AI Quota còn lại
    get aiQuotaRemainingMinutes(): number {
      return aiQuotaUtils.getAiQuotaRemainingMinutes(this.aiQuota);
    }

    /// Tổng hạn mức AI (baseAllocatedMinutes + purchasedMinutes)
    get aiQuotaTotalMinutes(): number {
      return aiQuotaUtils.getAiQuotaTotalMinutes(this.aiQuota);
    }

    /// Giá trị max cho progress bar AI Quota
    get aiQuotaProgressMax(): number {
      return aiQuotaUtils.getAiQuotaProgressMax(this.aiQuota);
    }

    /// Giá trị value cho progress bar AI Quota
    get aiQuotaProgressValue(): number {
      return aiQuotaUtils.getAiQuotaProgressValue(this.aiQuota);
    }

    /// Số phút AI Quota đã sử dụng
    get aiQuotaUsedMinutes(): number {
      return aiQuotaUtils.getAiQuotaUsedMinutes(this.aiQuota);
    }

    /// Label phần trăm cho progress bar AI Quota
    get aiQuotaProgressLabel(): string {
      return aiQuotaUtils.getAiQuotaProgressLabel(this.aiQuota);
    }

    /// Ngày reset AI Quota (cycleEnd, format DD/MM/YYYY)
    get aiQuotaCycleStartFormatted(): string {
      return aiQuotaUtils.formatAiQuotaCycleStart(this.aiQuota?.cycleEnd);
    }

    /// Mã màu trạng thái AI Quota
    get aiQuotaStatusColor(): string {
      return aiQuotaUtils.getAiQuotaStatusColor(this.aiQuota);
    }

    /// Mở hướng dẫn sử dụng GMToken
    onOpenGuideGMToken(token) {
      window.open('https://gomeet.vnpt.vn/docs/docs/widget/token', '_blank');
    }

    /// Sao chép GMToken
    async onCopyGMToken() {
      if (!this.gmTokenInfo) {
        return;
      }
      await navigator.clipboard.writeText(this.gmTokenInfo.token);
      this.toastSuccess(this.$t("alert").toString(), this.$t("copied").toString());
    }

    /// Mở modal quản lý dung lượng lưu trữ
    onOpenManageStorage() {
      this.$bvModal.show("manage-storage-modal");
    }

    /// Xoá tài khoản
    async deleteAccount() {
      const modalMessage = this.$t("deleteYourAccount").toString();
      const confirmDelete = await this.$bvModal.msgBoxConfirm(modalMessage, {
        okVariant: 'danger',
        okTitle: this.$t("yes").toString(),
        cancelTitle: this.$t("no").toString(),
      });

      if (confirmDelete) {
        try {
          this.showLoading();
          await userService.deleteUser(this.userId).then((data)=>{
            userService.signOut();
          });
        } catch (e) {
          this.toastError(e);

        } finally {
          this.hideLoading();
        }
      }
    }

    /// Load lại page
    onReloadPage() {
      location.reload();
    }

  }
</script>
